import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import IssueTypeLabel from '@hydra/routes/crawler/components/IssueTypeLabel';

import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import { Label } from '@hydra/common/components';
import { Grid } from '@material-ui/core';

export class TitleIssueRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const urls = issue.urls.map(url => new DCUrl(domain, url));
    return (
      <Grid container className={classNameProp} alignItems='flex-start' key={issue.id || issue.__id}>
        <Grid item {...columnStyles[0]}>
          <IssueTypeLabel severity={issue.severity} type={issue.type} amount={issue.urls.length} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          <Label noBackground truncate>
            {`${issue.title_len_chr} (${issue.title_len_px}px)`}
          </Label>
        </Grid>
        <Grid item {...columnStyles[2]}>
          <Label noBackground title={issue.title} truncate>
            {issue.title}
          </Label>
        </Grid>
        <Grid item {...columnStyles[3]}>
          <List style={parseSeverity(issue.severity)} items={urls} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(TitleIssueRow, {
  issue: graphql`
    fragment TitleIssueRow_issue on TitleIssue {
      id
      severity
      title
      title_len_chr
      title_len_px
      type
      urls
    }
  `
});
